import type { SVGProps } from 'react';

export function FlowerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.564 10.931a11 11 0 0 1 3.33 2.794c.416.521.787 1.084 1.102 1.68q.478-.893 1.103-1.68A10.935 10.935 0 0 1 21.668 9.6h.37c.417 0 .755.338.755.754 0 5.55-4.497 10.046-10.047 10.046H11.24C5.696 20.4 1.2 15.904 1.2 10.354c0-.416.338-.754.754-.754h.371c1.89 0 3.679.48 5.239 1.331m5.032-7.106c.634.596 2.303 2.378 3.338 5.336A12.75 12.75 0 0 0 12 12.241a12.9 12.9 0 0 0-3.934-3.08c1.035-2.958 2.708-4.74 3.338-5.336A.85.85 0 0 1 12 3.6c.221 0 .435.075.596.225" />
    </svg>
  );
}
